export default __webpack_public_path__ + "static/media/HoodSteam.08e05b70.jpg";